﻿export default [
    {
        Key: 'DSB-Home',
        Name: 'Dashboard',
        Icon: 'dashboard',
        Path: '/',
    },
    {
        Key: 'CST',
        Name: 'Customers',
        Module: 'CST',
        Icon: 'people',
        Path: '/cst/customers/search',
    },
    {
        Key: 'PRD',
        Name: 'Products',
        Module: 'PRD',
        Icon: 'category',
        Path: '/prd/versions/search',
    },
    {
        Key: 'ISS',
        Name: 'Issues',
        Module: 'ISS',
        Icon: 'report',
        Path: '/iss/issues/search',
    }
]